export const languages = [
  { value: "Acehnese", label: "Acehnese" },
  { value: "Afrikaans", label: "Afrikaans" },
  { value: "Albanian", label: "Albanian" },
  { value: "Amharic", label: "Amharic" },
  { value: "Arabic", label: "Arabic" },
  { value: "Aragonese", label: "Aragonese" },
  { value: "Armenian", label: "Armenian" },
  { value: "Assamese", label: "Assamese" },
  { value: "Asturian", label: "Asturian" },
  { value: "Avar", label: "Avar" },
  { value: "Aymara", label: "Aymara" },
  { value: "Bambara", label: "Bambara" },
  { value: "Balinese", label: "Balinese" },
  { value: "Basque", label: "Basque (Euskara)" },
  { value: "Batak", label: "Batak" },
  { value: "Belarusian", label: "Belarusian" },
  { value: "Bemba", label: "Bemba" },
  { value: "Bengali", label: "Bengali" },
  { value: "Berber", label: "Berber (Tamazight)" },
  { value: "Bislama", label: "Bislama" },
  { value: "Bodo", label: "Bodo" },
  { value: "Bosnian", label: "Bosnian" },
  { value: "Breton", label: "Breton" },
  { value: "Bugis", label: "Bugis" },
  { value: "Bulgarian", label: "Bulgarian" },
  { value: "Burmese", label: "Burmese" },
  { value: "Catalan", label: "Catalan" },
  { value: "Chamorro", label: "Chamorro" },
  { value: "Chechen", label: "Chechen" },
  { value: "Cherokee", label: "Cherokee" },
  { value: "Chinese", label: "Chinese (Mandarin)" },
  { value: "Cantonese", label: "Chinese (Cantonese)" },
  { value: "Chichewa", label: "Chichewa (Nyanja)" },
  { value: "Chuvash", label: "Chuvash" },
  { value: "Corsican", label: "Corsican" },
  { value: "Cree", label: "Cree" },
  { value: "Croatian", label: "Croatian" },
  { value: "Czech", label: "Czech" },
  { value: "Danish", label: "Danish" },
  { value: "Dagestani", label: "Dagestani" },
  { value: "Dutch", label: "Dutch" },
  { value: "Dzongkha", label: "Dzongkha (Bhutan)" },
  { value: "English", label: "English" },
  { value: "Esperanto", label: "Esperanto" },
  { value: "Estonian", label: "Estonian" },
  { value: "Ewe", label: "Ewe" },
  { value: "Faroese", label: "Faroese" },
  { value: "Fijian", label: "Fijian" },
  { value: "Finnish", label: "Finnish" },
  { value: "French", label: "French" },
  { value: "Frisian", label: "Frisian" },
  { value: "Fula", label: "Fula (Fulani)" },
  { value: "Ga", label: "Ga" },
  { value: "Galician", label: "Galician" },
  { value: "Georgian", label: "Georgian" },
  { value: "German", label: "German" },
  { value: "Greek", label: "Greek" },
  { value: "Greenlandic", label: "Greenlandic (Kalaallisut)" },
  { value: "Gujarati", label: "Gujarati" },
  { value: "Haitian Creole", label: "Haitian Creole" },
  { value: "Hausa", label: "Hausa" },
  { value: "Hawaiian", label: "Hawaiian" },
  { value: "Hebrew", label: "Hebrew" },
  { value: "Hindi", label: "Hindi" },
  { value: "Hmong", label: "Hmong" },
  { value: "Hopi", label: "Hopi" },
  { value: "Hungarian", label: "Hungarian" },
  { value: "Icelandic", label: "Icelandic" },
  { value: "Igbo", label: "Igbo" },
  { value: "Indonesian", label: "Indonesian" },
  { value: "Inuktitut", label: "Inuktitut (Inuit)" },
  { value: "Interlingua", label: "Interlingua" },
  { value: "Irish", label: "Irish Gaelic" },
  { value: "Italian", label: "Italian" },
  { value: "Japanese", label: "Japanese" },
  { value: "Javanese", label: "Javanese" },
  { value: "Kabyle", label: "Kabyle" },
  { value: "Kannada", label: "Kannada" },
  { value: "Kanuri", label: "Kanuri" },
  { value: "Karen", label: "Karen" },
  { value: "Kazakh", label: "Kazakh" },
  { value: "Khasi", label: "Khasi" },
  { value: "Khmer", label: "Khmer (Cambodian)" },
  { value: "Kinyarwanda", label: "Kinyarwanda" },
  { value: "Kiribati", label: "Kiribati (Gilbertese)" },
  { value: "Kirundi", label: "Kirundi" },
  { value: "Kongo", label: "Kongo" },
  { value: "Konkani", label: "Konkani" },
  { value: "Korean", label: "Korean" },
  { value: "Kurdish", label: "Kurdish" },
  { value: "Kyrgyz", label: "Kyrgyz" },
  { value: "Ladino", label: "Ladino (Judeo-Spanish)" },
  { value: "Lao", label: "Lao" },
  { value: "Latin", label: "Latin" },
  { value: "Latvian", label: "Latvian" },
  { value: "Lingala", label: "Lingala" },
  { value: "Lithuanian", label: "Lithuanian" },
  { value: "Luganda", label: "Luganda" },
  { value: "Luxembourgish", label: "Luxembourgish" },
  { value: "Macedonian", label: "Macedonian" },
  { value: "Madurese", label: "Madurese" },
  { value: "Maithili", label: "Maithili" },
  { value: "Malay", label: "Malay" },
  { value: "Malayalam", label: "Malayalam" },
  { value: "Maltese", label: "Maltese" },
  { value: "Mandarin", label: "Chinese (Mandarin)" },
  { value: "Manx", label: "Manx Gaelic" },
  { value: "Maori", label: "Māori" },
  { value: "Mapudungun", label: "Mapudungun" },
  { value: "Marathi", label: "Marathi" },
  { value: "Marshallese", label: "Marshallese" },
  { value: "Mayan", label: "Mayan" },
  { value: "Minangkabau", label: "Minangkabau" },
  { value: "Mongolian", label: "Mongolian" },
  { value: "Montenegrin", label: "Montenegrin" },
  { value: "Mossi", label: "Mossi" },
  { value: "Navajo", label: "Navajo" },
  { value: "Nepali", label: "Nepali" },
  { value: "Norwegian", label: "Norwegian" },
  { value: "Occitan", label: "Occitan" },
  { value: "Odia", label: "Odia (Oriya)" },
  { value: "Ojibwe", label: "Ojibwe" },
  { value: "Oromo", label: "Oromo" },
  { value: "Palauan", label: "Palauan" },
  { value: "Papiamento", label: "Papiamento" },
  { value: "Pashto", label: "Pashto" },
  { value: "Persian", label: "Persian (Farsi)" },
  { value: "Picard", label: "Picard" },
  { value: "Polish", label: "Polish" },
  { value: "Portuguese", label: "Portuguese" },
  { value: "Punjabi", label: "Punjabi" },
  { value: "Quechua", label: "Quechua" },
  { value: "Romanian", label: "Romanian" },
  { value: "Romansh", label: "Romansh" },
  { value: "Rohingya", label: "Rohingya" },
  { value: "Russian", label: "Russian" },
  { value: "Samoan", label: "Samoan" },
  { value: "Santali", label: "Santali" },
  { value: "Sardinian", label: "Sardinian" },
  { value: "Scottish Gaelic", label: "Scottish Gaelic" },
  { value: "Serbian", label: "Serbian" },
  { value: "Sesotho", label: "Sesotho" },
  { value: "Sesotho sa Leboa", label: "Northern Sotho (Sepedi)" },
  { value: "Shona", label: "Shona" },
  { value: "Sindhi", label: "Sindhi" },
  { value: "Sinhala", label: "Sinhala" },
  { value: "Slovak", label: "Slovak" },
  { value: "Slovenian", label: "Slovenian" },
  { value: "Somali", label: "Somali" },
  { value: "Spanish", label: "Spanish" },
  { value: "Sundanese", label: "Sundanese" },
  { value: "Swahili", label: "Swahili" },
  { value: "Swedish", label: "Swedish" },
  { value: "Tagalog", label: "Tagalog (Filipino)" },
  { value: "Tamil", label: "Tamil" },
  { value: "Tamasheq", label: "Tamasheq (Tuareg)" },
  { value: "Tatar", label: "Tatar" },
  { value: "Telugu", label: "Telugu" },
  { value: "Thai", label: "Thai" },
  { value: "Tibetan", label: "Tibetan" },
  { value: "Tigrinya", label: "Tigrinya" },
  { value: "Tok Pisin", label: "Tok Pisin" },
  { value: "Tongan", label: "Tongan" },
  { value: "Tsonga", label: "Tsonga" },
  { value: "Tswana", label: "Tswana" },
  { value: "Turkish", label: "Turkish" },
  { value: "Turkmen", label: "Turkmen" },
  { value: "Twi", label: "Twi (Akan)" },
  { value: "Uighur", label: "Uighur" },
  { value: "Ukrainian", label: "Ukrainian" },
  { value: "Urdu", label: "Urdu" },
  { value: "Uzbek", label: "Uzbek" },
  { value: "Venda", label: "Venda" },
  { value: "Vietnamese", label: "Vietnamese" },
  { value: "Walloon", label: "Walloon" },
  { value: "Welsh", label: "Welsh" },
  { value: "Wolof", label: "Wolof" },
  { value: "Xhosa", label: "Xhosa" },
  { value: "Yiddish", label: "Yiddish" },
  { value: "Yoruba", label: "Yoruba" },
  { value: "Zulu", label: "Zulu" }
];
